module.exports = __webpack_public_path__ + "img/Mockup3.93e2d605.webp";